import firebase from "firebase";

firebase.initializeApp({
  apiKey: "AIzaSyCXjpQRiMO-0BIHxIxQVv0aBqtvNKpm734",
  authDomain: "rumah-sakit-kita-d1035.firebaseapp.com",
  databaseURL: "https://rumah-sakit-kita-d1035-default-rtdb.firebaseio.com",
  projectId: "rumah-sakit-kita-d1035",
  storageBucket: "rumah-sakit-kita-d1035.appspot.com",
  messagingSenderId: "286132524760",
  appId: "1:286132524760:web:7894e980b904b26441e9ad",
  measurementId: "G-MYY32GRCG6"
});

const FIREBASE = firebase;

export default FIREBASE;